import { Outlet } from 'react-router-dom';
import { BrandLogo } from '@/components/brand-logo';
import { ThemeToggle } from '@/components/theme-toggle';
import { PRODUCT } from '@/config/product';

/**
 * Layout das páginas públicas (login, register).
 * Dois painéis no desktop: lado esquerdo com branding e tagline, lado direito
 * com o formulário. No mobile vira empilhado.
 */
export function AuthShell() {
  return (
    <div className="min-h-screen bg-background text-foreground lg:grid lg:grid-cols-2">
      {/* Painel marketing / branding */}
      <aside className="relative hidden overflow-hidden bg-[hsl(var(--sidebar))] text-[hsl(var(--sidebar-foreground))] lg:flex lg:flex-col lg:justify-between lg:p-10 xl:p-14">
        <div className="relative z-10">
          <BrandLogo variant="inverted" size="lg" />
        </div>

        {/* Gradiente sutil de fundo */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 opacity-60"
          style={{
            backgroundImage:
              'radial-gradient(circle at 20% 10%, hsl(211 80% 35% / 0.45), transparent 55%), radial-gradient(circle at 80% 90%, hsl(158 60% 30% / 0.35), transparent 50%)',
          }}
        />

        <div className="relative z-10 max-w-md space-y-6">
          <h1 className="font-sans text-4xl font-semibold leading-[1.1] tracking-tight xl:text-5xl">
            Gestão de frota sem planilha, sem drama.
          </h1>
          <p className="text-base leading-relaxed text-[hsl(var(--sidebar-foreground)/0.75)] xl:text-lg">
            Controle abastecimento, manutenção, multas e checklists digitais em um só lugar.
            Motorista faz o checklist no celular, mesmo sem sinal.
          </p>

          <ul className="space-y-3 text-sm text-[hsl(var(--sidebar-foreground)/0.85)]">
            {[
              'Checklist digital offline no Android/iOS',
              'Alertas automáticos de manutenção e CNH',
              'Relatórios de consumo e anomalias de combustível',
              'Multi-usuário com permissões por papel',
            ].map((line) => (
              <li key={line} className="flex items-start gap-2.5">
                <svg
                  className="mt-0.5 size-4 flex-shrink-0 text-[hsl(158_64%_55%)]"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.704 5.29a1 1 0 010 1.42l-8 8a1 1 0 01-1.42 0l-4-4a1 1 0 011.42-1.42L8 12.58l7.293-7.29a1 1 0 011.41 0z"
                    clipRule="evenodd"
                  />
                </svg>
                {line}
              </li>
            ))}
          </ul>
        </div>

        <footer className="relative z-10 text-xs text-[hsl(var(--sidebar-foreground)/0.6)]">
          © {new Date().getFullYear()} {PRODUCT.name} · {PRODUCT.tagline}
        </footer>
      </aside>

      {/* Painel do formulário */}
      <main className="relative flex min-h-screen flex-col px-6 py-10 sm:px-10 lg:min-h-0 lg:px-12 lg:py-12 xl:px-20">
        <div className="flex items-center justify-between lg:hidden">
          <BrandLogo />
          <ThemeToggle />
        </div>
        <div className="absolute right-6 top-6 hidden lg:block">
          <ThemeToggle />
        </div>

        <div className="flex flex-1 items-center justify-center py-10">
          <div className="w-full max-w-md animate-fade-in">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
